import {TreeAvatarBorderType, TreePersistFieldNameEnum} from '@api/models'

export enum FieldTypeEnum {
  color = 'color',
  number = 'number',
  select = 'select',
  switch = 'switch',
}

export const SECTION_ORDER = [
  {
    id: 'tree',
    label: 'TREE.STYLING.TREE',
  },
  {
    id: 'sims',
    label: 'TREE.STYLING.SIMS',
  },
  {
    id: 'pets',
    label: 'TREE.STYLING.PETS_HEADING',
  },
  {
    id: 'occult',
    label: 'TREE.STYLING.OCCULT',
  },
]

export const FIELDS_ORDER = [
  {
    name: TreePersistFieldNameEnum.lineColor,
    type: FieldTypeEnum.color,
    label: 'TREE.STYLING.LINE.COLOR',
    hint: 'TREE.STYLING.LINE.COLOR.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.lineWidth,
    type: FieldTypeEnum.number,
    label: 'TREE.STYLING.LINE.THICKNESS',
    max: 10,
    hint: 'TREE.STYLING.LINE.THICKNESS.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.lineShadowColor,
    type: FieldTypeEnum.color,
    label: 'TREE.STYLING.HIGHLIGHT',
    hint: 'TREE.STYLING.HIGHLIGHT.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.lineShadowWidth,
    type: FieldTypeEnum.number,
    label: 'TREE.STYLING.HIGHLIGHT.THICKNESS',
    max: 70,
    hint: 'TREE.STYLING.HIGHLIGHT.THICKNESS.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.firstNameDisplayingEnabled,
    type: FieldTypeEnum.switch,
    label: 'TREE.STYLING.FIRSTNAME_DISPLAYING',
    forAll: true,
    hint: 'TREE.STYLING.FIRSTNAME_DISPLAYING.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.lastNameDisplayingEnabled,
    type: FieldTypeEnum.switch,
    label: 'TREE.STYLING.LASTNAME_DISPLAYING',
    forAll: true,
    hint: 'TREE.STYLING.LASTNAME_DISPLAYING.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.fullNameColor,
    type: FieldTypeEnum.color,
    label: 'TREE.STYLING.FULLNAME_COLOR',
    forAll: true,
    hint: 'TREE.STYLING.FULLNAME_COLOR.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.diedStatusDisplayingEnabled,
    type: FieldTypeEnum.switch,
    label: 'TREE.STYLING.DIED_STATUS_DISPLAYING',
    forAll: true,
    hint: 'TREE.STYLING.DIED_STATUS_DISPLAYING.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.diedStatusColor,
    type: FieldTypeEnum.color,
    label: 'TREE.STYLING.DIED_STATUS_COLOR',
    forAll: true,
    hint: 'TREE.STYLING.DIED_STATUS_COLOR.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.heirLineEnabled,
    type: FieldTypeEnum.switch,
    label: 'TREE.STYLING.HEIR.LINE',
    forAll: true,
    hint: 'TREE.STYLING.HEIR.LINE.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.heirLineColor,
    type: FieldTypeEnum.color,
    label: 'TREE.STYLING.HEIR.LINE.COLOR',
    forAll: true,
    hint: 'TREE.STYLING.HEIR.LINE.COLOR.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.petsDisplayingOnTreeEnabled,
    type: FieldTypeEnum.switch,
    label: 'TREE.STYLING.PETS',
    forAll: true,
    hint: 'TREE.STYLING.PETS.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.avatarShadowDisplaying,
    type: FieldTypeEnum.switch,
    label: 'TREE.STYLING.AVTSHADOW.DISPLAYING',
    forAll: true,
    hint: 'TREE.STYLING.AVTSHADOW.DISPLAYING.HINT',
    section: 'tree',
  },
  {
    name: TreePersistFieldNameEnum.avatarShadowColor,
    type: FieldTypeEnum.color,
    label: 'TREE.STYLING.AVTSHADOW.COLOR',
    forAll: true,
    hint: 'TREE.STYLING.AVTSHADOW.COLOR.HINT',
    section: 'tree',
  },

  // sims section
  {
    name: TreePersistFieldNameEnum.avatarBorderColor,
    type: FieldTypeEnum.color,
    label: 'TREE.STYLING.AVTBORDER.COLOR',
    hint: 'TREE.STYLING.AVTBORDER.COLOR.HINT',
    section: 'sims',
  },
  // {
  //   name: TreePersistFieldNameEnum.avatarBorderColorMain,
  //   type: FieldTypeEnum.color,
  //   label: 'TREE.STYLING.AVTBORDER.COLOR_MAIN',
  //   hint: 'TREE.STYLING.AVTBORDER.COLOR.HINT',
  //   section: 'sims',
  // },
  {
    name: TreePersistFieldNameEnum.avatarBorderWidth,
    type: FieldTypeEnum.number,
    label: 'TREE.STYLING.AVTBORDER.THICKNESS',
    max: 10,
    hint: 'TREE.STYLING.AVTBORDER.THICKNESS.HINT',
    section: 'sims',
  },
  {
    name: TreePersistFieldNameEnum.avatarBorderRadius,
    type: FieldTypeEnum.number,
    label: 'TREE.STYLING.AVT.RADIUS',
    max: 100,
    hint: 'TREE.STYLING.AVT.RADIUS.HINT',
    section: 'sims',
  },
  {
    name: TreePersistFieldNameEnum.avatarBorderType,
    type: FieldTypeEnum.select,
    label: 'TREE.STYLING.AVTBORDER.TYPE',
    options: [
      {
        id: TreeAvatarBorderType.solid,
        label: 'TREE.STYLING.LINE.SOLID',
      },
      {
        id: TreeAvatarBorderType.dotted,
        label: 'TREE.STYLING.LINE.DOTTED',
      },
      {
        id: TreeAvatarBorderType.dashed,
        label: 'TREE.STYLING.LINE.DASHED',
      },
      {
        id: TreeAvatarBorderType.double,
        label: 'TREE.STYLING.LINE.DOUBLE',
      },
    ],
    hint: 'TREE.STYLING.AVTBORDER.TYPE.HINT',
    section: 'sims',
  },

  // pets section
  {
    name: TreePersistFieldNameEnum.petBorderColor,
    type: FieldTypeEnum.color,
    label: 'TREE.STYLING.PETBORDER.COLOR',
    hint: 'TREE.STYLING.PETBORDER.COLOR.HINT',
    section: 'pets',
  },
  {
    name: TreePersistFieldNameEnum.petBorderWidth,
    type: FieldTypeEnum.number,
    label: 'TREE.STYLING.PETBORDER.THICKNESS',
    max: 10,
    hint: 'TREE.STYLING.PETBORDER.THICKNESS.HINT',
    section: 'pets',
  },
  {
    name: TreePersistFieldNameEnum.petBorderRadius,
    type: FieldTypeEnum.number,
    label: 'TREE.STYLING.PETBORDER.RADIUS',
    max: 100,
    hint: 'TREE.STYLING.PETBORDER.RADIUS.HINT',
    section: 'pets',
  },
  {
    name: TreePersistFieldNameEnum.petBorderType,
    type: FieldTypeEnum.select,
    label: 'TREE.STYLING.PETBORDER.TYPE',
    options: [
      {
        id: TreeAvatarBorderType.solid,
        label: 'TREE.STYLING.LINE.SOLID',
      },
      {
        id: TreeAvatarBorderType.dotted,
        label: 'TREE.STYLING.LINE.DOTTED',
      },
      {
        id: TreeAvatarBorderType.dashed,
        label: 'TREE.STYLING.LINE.DASHED',
      },
      {
        id: TreeAvatarBorderType.double,
        label: 'TREE.STYLING.LINE.DOUBLE',
      },
    ],
    hint: 'TREE.STYLING.PETBORDER.TYPE.HINT',
    section: 'pets',
  },

  // occults section
  {
    name: TreePersistFieldNameEnum.cultBorderColor,
    type: FieldTypeEnum.color,
    label: 'TREE.STYLING.CULTBORDER.COLOR',
    hint: 'TREE.STYLING.CULTBORDER.COLOR.HINT',
    section: 'occult',
  },
  {
    name: TreePersistFieldNameEnum.cultBorderWidth,
    type: FieldTypeEnum.number,
    label: 'TREE.STYLING.CULTBORDER.THICKNESS',
    max: 10,
    hint: 'TREE.STYLING.CULTBORDER.THICKNESS.HINT',
    section: 'occult',
  },
  {
    name: TreePersistFieldNameEnum.cultBorderRadius,
    type: FieldTypeEnum.number,
    label: 'TREE.STYLING.CULTBORDER.RADIUS',
    max: 100,
    hint: 'TREE.STYLING.CULTBORDER.RADIUS.HINT',
    section: 'occult',
  },
  {
    name: TreePersistFieldNameEnum.cultBorderType,
    type: FieldTypeEnum.select,
    label: 'TREE.STYLING.CULTBORDER.TYPE',
    options: [
      {
        id: TreeAvatarBorderType.solid,
        label: 'TREE.STYLING.LINE.SOLID',
      },
      {
        id: TreeAvatarBorderType.dotted,
        label: 'TREE.STYLING.LINE.DOTTED',
      },
      {
        id: TreeAvatarBorderType.dashed,
        label: 'TREE.STYLING.LINE.DASHED',
      },
      {
        id: TreeAvatarBorderType.double,
        label: 'TREE.STYLING.LINE.DOUBLE',
      },
    ],
    hint: 'TREE.STYLING.CULTBORDER.TYPE.HINT',
    section: 'occult',
  },
]
